import React, { useState } from "react";
import { Layout, Menu, Drawer, Button, Grid, Col, Row } from "antd";
import {
  HomeOutlined,
  ContactsOutlined,
  InfoCircleOutlined,
  AppstoreAddOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Route, Routes, Link, useLocation } from "react-router-dom"; // ✅ useLocation imported

import HomePage from "./home";
import AboutPage from "./about";
import ServicesPage from "./service/index";
import ContactPage from "./contact/index";

import Logo1 from "../assests/images/Shivant hr consultancy (2).png";
import styles from "./company.module.scss";

const { Header, Content, Footer } = Layout;
const { useBreakpoint } = Grid;

const CompanyPage: React.FC = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const location = useLocation(); // ✅ useLocation hook
  const pathname = location.pathname;

  // Determine the selected menu key
  const selectedKey = pathname === "/" ? "home" : pathname.replace("/", "");

  const showDrawer = () => setDrawerVisible(true);
  const onClose = () => setDrawerVisible(false);

  const menuItems = [
    {
      key: "home",
      icon: <HomeOutlined />,
      label: <Link to="/home">Home</Link>,
    },
    {
      key: "about",
      icon: <InfoCircleOutlined />,
      label: <Link to="/about">About</Link>,
    },
    {
      key: "services",
      icon: <AppstoreAddOutlined />,
      label: <Link to="/services">Services</Link>,
    },
    {
      key: "contact",
      icon: <ContactsOutlined />,
      label: <Link to="/contact">Contact</Link>,
    },
  ];

  return (
    <Layout style={{ background:"black", width: "100%" }}>
      <Header style={{ background: "#001529", position: "sticky", top: 0, zIndex: 1000, width: "100%", height: "120px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={Logo1} alt="Logo" className={styles["header-logo"]} style={{ maxHeight: "80px" }} />
          <p style={{ color: "#ffb859" }} className={styles["logo-text"]}>
            Shivant <span style={{ color: "#23a9ff" }}>HR</span> Consultancy
          </p>
        </div>

        {screens.md ? (
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[selectedKey]} // ✅ This syncs with URL
            style={{ lineHeight: "64px" }}
            items={menuItems}
          />
        ) : (
          <>
            <Button className="menu-button" type="text" icon={<MenuOutlined style={{ fontSize: "24px", color: "white" }} />} onClick={showDrawer} />
            <Drawer
              title="Menu"
              placement="right"
              closable
              onClose={onClose}
              open={drawerVisible}
              className="mobile-drawer"
              drawerStyle={{ backgroundColor: "#001529" }}
              headerStyle={{ backgroundColor: "#001529", color: "#fff" }}
              bodyStyle={{ color: "#fff" }}
            >
              <Menu
                theme="dark"
                mode="vertical"
                selectedKeys={[selectedKey]} // ✅ Works for drawer too
                items={menuItems}
                onClick={onClose}
              />
            </Drawer>
          </>
        )}
      </Header>

      <Content style={{ padding: "0 20px", marginTop: 20 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Content>
  {/* Footer (optional) */}
  <Footer  style={{
            backgroundColor: "#001529",
            color: "white",
            padding: "40px 80px",
          }}
>
          <Row gutter={[24, 24]}>
            {/* About Us Section */}
            <Col xs={24} md={6}>
              <h3>About Us</h3>
              <p>
                Shivant HR  Consultancy is a highly acclaimed recruitment and
                executive search company providing discerning talent recruitment
                services to a strong and large list of clients in all major
                cities across India.
              </p>
              <Button type="link" style={{ color: "white" }}>
                <Link to="/about">READ MORE +</Link>
              </Button>
             </Col>

            {/* Quick Links Section */}
            <Col xs={24} md={6}>
              <h3>Quick Links</h3>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ padding: 6 }}>
                  <Link to="/home" style={{ color: "white" }}>
                    Home
                  </Link>
                </li>
                <li style={{ padding: 6 }}>
                  <Link to="/about" style={{ color: "white" }}>
                    About us
                  </Link>
                </li>
               <li style={{ padding: 6 }}>
                  <Link to="/services" style={{ color: "white" }}>
                    Services
                  </Link>
                </li>
                 <li style={{ padding: 6 }}>
                  <Link to="/contact" style={{ color: "white" }}>
                    Contact us
                   </Link>
               </li>
              </ul>
            </Col>

            {/* Our Services Section */}
            <Col xs={24} md={6}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ padding: 6 }}>Leadership Hiring</li>
                <li style={{ padding: 6 }}>Permanent Staffing</li>
                 <li style={{ padding: 6 }}>Contract Staffing</li>
<li style={{ padding: 6 }}>Specialist Hiring</li>
              </ul>
            </Col>

            {/* Contact Details Section */}
            <Col xs={24} md={6}>
              <h3>Contact Details</h3>
              <p>
              Dwarka Mor,New Delhi, 110059
              </p>
              {/* <p>+91  7042500421</p> */}
              <p>
                <a href="mailto:hr@sudhmura.com" style={{ color: "white" }}>
                  sevices@shivanthrconsultancy.com
                </a>
              </p>
            </Col>
          </Row>

          <p style={{ marginTop: "30px", padding: 6 }}>
             ©{new Date().getFullYear()} Shivant Hr Consultancy. All Rights Reserved.
          </p>
        </Footer>
    </Layout>
  );
};

export default CompanyPage;
